import React from "react";
import { BillsActionBarSkeleton } from "@features/skeletons/Bills/BillsActionBarSkeleton/BillsActionBarSkeleton";
import { JointBillTableSkeleton } from "@features/skeletons/Bills/JointBillTableSkeleton/JointBillTableSkeleton";
import { ButtonSkeleton } from "@features/skeletons/common/ButtonSkeleton/ButtonSkeleton";
import { PageLayoutSkeleton } from "@features/skeletons/common/PageLayoutSkeleton/PageLayoutSkeleton";

export const BillsPageSkeleton: React.FC = () => {
  return (
    <PageLayoutSkeleton actionBarSkeleton={<BillsActionBarSkeleton />}>
      <>
        <div className="px-4 pb-5 sm:hidden md:pb-4">
          <ButtonSkeleton className="w-full" />
        </div>
        <div className="mx-0 flex flex-col gap-6">
          <JointBillTableSkeleton />
        </div>
      </>
    </PageLayoutSkeleton>
  );
};
